<template>
  <div>
    <a-card title="销售单详情">
      <a-button slot="extra" type="primary" style="margin-right: 8px;" ghost v-print="'#printContent'"> <a-icon type="printer" />打印</a-button>
      <a-button slot="extra" type="primary" ghost @click="() => { this.$router.go(-1); }"> <a-icon type="left" />返回</a-button>
      <section id="printContent">
        <a-spin :spinning="loading">
          <img id="barcode" style="float: right" />
          <a-descriptions bordered>
            <a-descriptions-item label="销售编号">
              {{ info.number }}
            </a-descriptions-item>
            <a-descriptions-item label="销售单号">
              {{ info.sales_order }}
            </a-descriptions-item>
            <a-descriptions-item label="客户">
              {{ info.client_name }}
            </a-descriptions-item>
            <a-descriptions-item label="仓库">
              {{ info.warehouse_name }}
            </a-descriptions-item>
            <a-descriptions-item label="经手人">
              {{ info.handler_name }}
            </a-descriptions-item>
            <a-descriptions-item label="处理日期">
              {{ info.handle_time }}
            </a-descriptions-item>
            <a-descriptions-item label="整单折扣">
              {{ info.discount }}
            </a-descriptions-item>
            <a-descriptions-item label="其他费用">
              {{ info.other_amount }}
            </a-descriptions-item>
            <a-descriptions-item label="开单金额">
              {{ orderAmount }}
            </a-descriptions-item>
            <a-descriptions-item label="结算金额">
              {{ settlePreview.total }}
            </a-descriptions-item>
            <a-descriptions-item label="实收金额">
              {{ info.collection_amount || 0 }}
            </a-descriptions-item>
            <a-descriptions-item label="本单欠款">
              {{ settlePreview.arrears }}
            </a-descriptions-item>
            <a-descriptions-item label="备注">
              {{ info.remark }}
            </a-descriptions-item>
          </a-descriptions>
          <!-- <a-divider orientation="left" style="margin-top: 30px;">结算账户信息</a-divider>
          <a-table
            rowKey="id"
            size="middle"
            :columns="columnsAccount"
            :data-source="info.sales_account_items"
            :pagination="false" /> -->
          <a-divider orientation="left" style="margin-top: 30px;">产品信息</a-divider>
          <a-table
            rowKey="id"
            size="middle"
            :columns="columns"
            :data-source="tableGoods"
            :pagination="false">
            <div slot="settle_price" slot-scope="value, item">
              <span v-if="!item.isTotal">{{ item.settle_input }}</span>
            </div>
          </a-table>
        </a-spin>
      </section>
    </a-card>
  </div>
</template>

<script>
  import { saleOrderDetail } from '@/api/sale'
  import { formatQtyWithUnit, toPackPrice, toUnitPrice } from '@/utils/pack'
  import JsBarcode from 'jsbarcode'
  import NP from 'number-precision'

export default {
    data() {
      return {
        loading: false,
        settleLines: [],
        materialLoading: false,
        receiptOrder: undefined,
        info: {},
        columns: [
          {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 45,
            customRender: (value, item, index) => {
              return item.isTotal ? '合计' : (index + 1)
            },
          },
          {
            title: '产品名称',
            dataIndex: 'goods_name',
            key: 'goods_name',
            width: 150,
          },
          {
            title: '产品编号',
            dataIndex: 'goods_number',
            key: 'goods_number',
            width: 150,
          },
          {
            title: '规格',
            dataIndex: 'goods_spec',
            key: 'goods_spec',
            width: 200,
          },
          {
            title: '销售数量',
            dataIndex: 'sales_quantity',
            key: 'sales_quantity',
            width: 140,
            customRender: (value, item) => {
              if (item.isTotal) return value;
              return formatQtyWithUnit(value, item) || (value == null ? '' : `${value} ${item.unit_name || ''}`.trim());
            },
          },
          {
            title: '开单价(元)',
            dataIndex: 'sales_price',
            key: 'sales_price',
            width: 120,
            customRender: (value, item) => {
              if (item.isTotal) return '';
              const p = toPackPrice(value, item);
              return p != null ? p : value;
            },
          },
          {
            title: '开单金额',
            dataIndex: 'total_amount',
            key: 'total_amount',
            width: 120,
            customRender: (value, item) => {
              if (item.isTotal) return item.total_amount;
              return value;
            },
          },
          {
            title: '结算单价(元)',
            dataIndex: 'settle_input',
            key: 'settle_price',
            width: 140,
            scopedSlots: { customRender: 'settle_price' },
          },
          {
            title: '结算金额',
            dataIndex: 'settle_amount',
            key: 'settle_amount',
            width: 120,
            customRender: (value, item) => {
              if (item.isTotal) return item.settle_total;
              const unit = toUnitPrice(item.settle_input, item);
              return NP.round(NP.times(item.sales_quantity || 0, unit || 0), 2);
            },
          }
        ],
        columnsAccount: [
          {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 45,
            customRender: (value, item, index) => {
              return item.isTotal ? '合计' : (index + 1)
            },
          },
          {
            title: '结算账户',
            dataIndex: 'account_name',
            key: 'account_name',
            width: 200,
          },
          {
            title: '付款金额',
            dataIndex: 'collection_amount',
            key: 'collection_amount',
            width: 200,
          }
        ],
      }
    },
    computed: {
      orderAmount() {
        if (this.info.order_amount != null) return this.info.order_amount;
        return this.info.total_amount;
      },
      tableGoods() {
        return [
          ...this.settleLines,
          {
            id: '-1',
            isTotal: true,
            sales_quantity: this.info.total_quantity,
            total_amount: this.orderAmount,
            settle_total: this.settlePreview.total,
          },
        ];
      },
      settlePreview() {
        let goodsAmount = 0;
        this.settleLines.forEach((item) => {
          goodsAmount = NP.plus(goodsAmount, this.lineSettleAmount(item));
        });
        const discount = this.info.discount == null ? 100 : this.info.discount;
        let total = NP.times(goodsAmount, discount, 0.01);
        total = NP.plus(total, this.info.other_amount || 0);
        return {
          total: NP.round(total, 2),
          arrears: NP.round(NP.minus(total, this.info.collection_amount || 0), 2),
        };
      },
    },
    created(){
      this.initData();
    },
    methods: {
      lineSettleAmount(item) {
        const unit = toUnitPrice(item.settle_input, item);
        return NP.round(NP.times(item.sales_quantity || 0, unit || 0), 2);
      },
      getJsBarcode(number) {
        JsBarcode("#barcode", number, {
          lineColor: '#000',
          width: 2,
          height: 40,
          displayValue: true
        });
      },
      initData() {
        this.loading = true;
        saleOrderDetail({ id: this.$route.query.id }).then(data => {
          this.info = data;
          this.settleLines = (data.sales_goods_items || []).map((item) => ({
            ...item,
            settle_input: toPackPrice(item.settle_price != null ? item.settle_price : item.sales_price, item),
          }));
          this.info.sales_account_items = [
            ...(this.info.sales_account_items || []),
            {
              id: '-1',
              isTotal: true,
              collection_amount: this.info.collection_amount,
            },
          ];
          this.getJsBarcode(data.number)
        }).finally(() => {
          this.loading = false;
        });
      },
    },
    mounted() {
      this.initData();
    },
  }
</script>
<style>
</style>
